import { render, staticRenderFns } from "./DefaultSectionDialog.vue?vue&type=template&id=3161de02"
import script from "./DefaultSectionDialog.vue?vue&type=script&lang=js"
export * from "./DefaultSectionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports